'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

exports.normalizeFormData = normalizeFormData;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _datetime = require('helpers/datetime');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function normalizeFormData(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var normalizedData = {};
  var _options$dateTimeFiel = options.dateTimeFields,
      dateTimeFields = _options$dateTimeFiel === undefined ? [] : _options$dateTimeFiel;


  (0, _entries2.default)(data).map(function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    if (val instanceof _moment2.default) {
      normalizedData[key] = val.format(dateTimeFields.includes(key) ? _datetime.dateFormat.sqlDateTime : _datetime.dateFormat.sql);
    } else if (typeof val === 'boolean') {
      normalizedData[key] = val ? 1 : 0;
    } else {
      normalizedData[key] = val;
    }
  });

  return normalizedData;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/forms.js
// module id = 526
// module chunks = 1